// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiPost, BASE_URL, retrieveToken } from "../../store/api";
import { JenisLembagaCreateResponse } from "./types";

import * as jenisLembagaActions from "./jenisLembaga.actions";
import { showModal } from "../modal/modal.actions";

export function* createJenisLembaga(
  action: ReturnType<typeof jenisLembagaActions.createJenisLembagaAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + 'jenis-lembaga';
    const result: Response = yield call(apiPost, url, token, action.payload);

    if (result.status === 201) {
      const parsed: JenisLembagaCreateResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'));
      yield put(jenisLembagaActions.createJenisLembagaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(jenisLembagaActions.createJenisLembagaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(showModal('Terjadi kesalahan pada server', 'Silahkan coba kembali dalam beberapa saat'));
    yield put(jenisLembagaActions.createJenisLembagaAsync.failure(parsed));
  }
}

export default function* jenisLembagaSagaCreateJenisLembaga() {
  yield takeEvery(jenisLembagaActions.createJenisLembagaAsync.request, createJenisLembaga);
}
